import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"90vh"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  class: "ofs RoomHistoryDetailModalScroll noscroll",
  style: {"height":"calc(90vh - 50px)"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {"width":"280px"}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969"}
  }, "担当者を変更")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "w100"
}
const _hoisted_7 = {
  key: 1,
  class: "w100 pad20"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mt20" }, [
  /*#__PURE__*/_createTextVNode(" 割り当てられた担当者には自動で通知がいきます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_9 = { class: "ml15 w100 mb20 mt20" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: `notify_members_`,
  class: "fs13 pointer"
}, " 調整相手にも通知", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_12 = {
  class: "fl",
  style: {"width":"400px"}
}
const _hoisted_13 = {
  class: "fl",
  style: {"width":"400px"}
}
const _hoisted_14 = {
  key: 0,
  class: "ml15"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: `use_current_url_`,
  class: "fs13 pointer"
}, " 現在のURLをそのまま利用", -1)
const _hoisted_16 = { key: 1 }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = {
  key: 1,
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_22 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_23 = {
  class: "posAb w30 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "閉じる", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  class: "posAb w70 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 whiteColor fw600" }, "担当者を決定して送信", -1)
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_MeetingAttendeesGroupAssignContent = _resolveComponent("MeetingAttendeesGroupAssignContent")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_LocationSelectContent = _resolveComponent("LocationSelectContent")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "ChangeMeetingAttendeesGroupModal",
    "content-class": "rad10 with_white_bg shadowContent modalWide noscroll FixScheduleModal",
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          class: "dismiss",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
        }, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
            width: "50",
            height: "50"
          }, null, 8, _hoisted_2)
        ]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, [
            (_ctx.step == 0 && _ctx.canGoNextPage)
              ? (_openBlock(), _createElementBlock("section", {
                  key: 0,
                  class: "fr pointer centered circle_button skyblueBg fs14 rad8 fw600 mt20",
                  style: {"width":"140px","height":"44px","padding":"11px 8px"},
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickNextStep && _ctx.clickNextStep(...args)))
                }, " 次へ "))
              : _createCommentVNode("", true),
            (_ctx.step == 1)
              ? (_openBlock(), _createElementBlock("section", {
                  key: 1,
                  class: "fr pointer centered circle_button lgreyBg fs14 rad8 fw600 mt20",
                  style: {"width":"140px","height":"44px","padding":"11px 8px"},
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickPreStep && _ctx.clickPreStep(...args)))
                }, " 戻る "))
              : _createCommentVNode("", true)
          ]),
          (_ctx.step == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_MeetingAttendeesGroupAssignContent, {
                  onSelectMag: _ctx.selectMag,
                  onSelectCategoryTab: _ctx.selectCategoryTab,
                  onUpdateTmpMag: _ctx.updateTmpMag
                }, null, 8, ["onSelectMag", "onSelectCategoryTab", "onUpdateTmpMag"])
              ]))
            : (_ctx.step == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_CheckboxTag, {
                      value: ``,
                      name: `notify_members`,
                      checked: _ctx.notifyMembers,
                      prefix: `notify_members`,
                      onClickCheckbox: _ctx.clickNotifyMembers,
                      style: {"margin-left":"1px"}
                    }, null, 8, ["checked", "onClickCheckbox"]),
                    _createTextVNode("   "),
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_TextareaTag, {
                        placeholder: "担当者を設定しました。当日はよろしくお願いします。",
                        style: {"height":"200px"},
                        class: "fl fs14 roundForm mw100",
                        value: _ctx.typedMessage,
                        onInputValue: _ctx.inputMessage
                      }, null, 8, ["value", "onInputValue"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      (_ctx.appo && _ctx.appo.is_online_meeting)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createVNode(_component_CheckboxTag, {
                              value: ``,
                              name: `use_current_url`,
                              checked: _ctx.useCurrentUrl,
                              prefix: `use_current_url`,
                              onClickCheckbox: _ctx.clickUseCurrentUrl,
                              style: {"margin-left":"1px"}
                            }, null, 8, ["checked", "onClickCheckbox"]),
                            _createTextVNode("   "),
                            _hoisted_15
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.useCurrentUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/mappin.png`),
                              width: "22",
                              height: "22",
                              class: "fl mr5 mt12 ml10"
                            }, null, 8, _hoisted_17),
                            _createVNode(_component_LocationSelectContent, {
                              class: "fl",
                              locationName: _ctx.getLocationName,
                              astag: _ctx.astag,
                              maxLength: 1,
                              onUpdate: _ctx.updateLocation
                            }, null, 8, ["locationName", "astag", "onUpdate"]),
                            _hoisted_18
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_19
                    ]),
                    _hoisted_20
                  ])
                ]))
              : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.step == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("section", {
                  class: "llgreyBg dgrey fs16 pointer centered",
                  style: {"line-height":"50px","height":"50px"},
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
                }, _hoisted_25)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("section", {
                  class: "w100 pinkBg fs16 pointer centered",
                  style: {"line-height":"50px","height":"50px"},
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                }, _hoisted_28)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onBeforeOpen"]))
}